import { snakeCase } from 'snake-case';

/*
 * @description Generic function for translating keys for API data calls
 */
// For now this is not nested, but it could be in the future
// https://auctane.atlassian.net/browse/PS-1311
function parseRecordToSnakeCase(data) {
  const kebabCaseObject = {};
  const dataKeys = Object.keys(data);
  dataKeys.forEach(key => {
    kebabCaseObject[snakeCase(key)] = data[key];
  });
  return kebabCaseObject;
}

/*
 * @description Generic function for removing falsy values for the backend
 */
// Types here are not great (string values will not be filtered), since we can't differentiate a string type from an empty string.
// Hopefully, it doesn't give problems since should be only used with backend communication
function cleanFalsyAPIValues(data) {
  const cleanedObject = {};
  const dataKeys = Object.keys(data);
  dataKeys.forEach(key => {
    const value = data[key];
    if (value !== '' && value !== undefined) {
      cleanedObject[key] = data[key];
    }
  });
  return cleanedObject;
}

export { cleanFalsyAPIValues, parseRecordToSnakeCase };
//# sourceMappingURL=api.js.map
